<template>
<div class="chapter">
<div class="inner_page">
<h2 class="heading">2</h2>
<p class="firstparagraph"><span class="dropcap">T</span>homas came out of work to find Nathaniel leaning against the bonnet of his car.<br/>‘Nice badge,’ Nathaniel said.</p>
<p class="basic-paragraph">Thomas hastened to remove it—<em class="italic">Thomas Salter, Store Manager</em>—but it was too late.</p>
<p class="basic-paragraph">Nathaniel was grinning. ‘Don’t be embarrassed. It makes you look important.’</p>
<p class="basic-paragraph">‘Ha ha.’</p>
<p class="basic-paragraph">‘Is it in case you forget who you are?’</p>
<p class="basic-paragraph">‘It’s so customers know who to shout at.’ Thomas unlocked the car.</p>
<p class="basic-paragraph">‘Does everyone wear badges these days?’ Nathaniel said, getting into the passenger seat.</p>
<p class="basic-paragraph">‘More or less.’</p>
<p class="basic-paragraph">‘Maybe I should get one.’</p>
<p class="basic-paragraph">Thomas looked at him, decided not to comment. Nathaniel like this was thrilling, his exuberance bleeding into everyone around him. But Thomas was on his guard, waiting for the switch, the tilt.</p>
<p class="basic-paragraph">‘Long day?’ Nathaniel said.</p>
<p class="basic-paragraph">He should have remembered how easily Nathaniel could read him. ‘Very.’</p>
<p class="basic-paragraph">Thomas made to turn on the engine, but Nathaniel put his hand on his arm and said, ‘Not yet. I want to talk to you. Before we pick up the others.’</p>
<p class="basic-paragraph">Thomas tried to relax his shoulders against the seat. Waited. Why were his responses never correct these days? He couldn’t seem to get himself under control.</p>
<p class="basic-paragraph">Nathaniel said, ‘God spoke to me again.’</p>
<p class="basic-paragraph">His hand was still on Thomas’s arm. All of Thomas’s consciousness was centred on that point of contact: Nathaniel’s hot palm, his spread fingers, pressing against Thomas’s body, thrusting their warmth deep below the skin. Thomas was almost trembling beneath that hand. It did something strange to him.</p>
<p class="basic-paragraph">He said, mouth dry, voice failing on the last syllable, ‘What did He say?’</p>
<p class="basic-paragraph">‘It’s been hard,’ Nathaniel said. ‘I haven’t been sure. I’ve been struggling with it. But it’s becoming clearer now.’</p>
<p class="basic-paragraph">‘Yes?’</p>
<p class="basic-paragraph">‘He’s found someone else.’</p>
<p class="basic-paragraph">‘What?’</p>
<p class="basic-paragraph">‘He wants me to bring in someone else.’</p>
<p class="basic-paragraph">‘Into the Ark?’</p>
<p class="basic-paragraph">Nathaniel nodded. He was watching Thomas, registering every flicker of his expression. Thomas took the cue, fought to make his reaction appropriate.</p>
<p class="basic-paragraph">‘I thought—’</p>
<p class="basic-paragraph">‘So did I. We were wrong.’</p>
<p class="basic-paragraph">‘Why now?’</p>
<p class="basic-paragraph">‘I don’t know.’</p>
<p class="basic-paragraph">Silence. At last, Nathaniel said, ‘I don’t need to tell you to keep this to yourself.’</p>
<p class="basic-paragraph">‘Of course.’</p>
<p class="basic-paragraph">‘I need to prepare the others a little. But I wanted you to know first.’ He smiled at Thomas. ‘You know you’re my right-hand man.’</p>
<p class="basic-paragraph">Thomas felt some of the old warmth, the kind that didn’t make him tremble. But it was battling with something else.</p>
<p class="basic-paragraph">He said, ‘Seth and Joshua will be waiting.’</p>
<p class="basic-paragraph">‘Let’s go, then.’</p>
<p class="basic-paragraph">Thomas turned on the engine and they headed towards the town centre. To his relief, Nathaniel didn’t try to talk any more. He knew that before long he would have to ask for guidance, even if it resulted in a session. Somehow it was as though he’d given the devil a way in, however careful he’d tried to be.</p>
<p class="basic-paragraph">Nathaniel had told them the Ark was already filled, sealed off from the outside world. So had God changed His mind? But no, Thomas could see that was a stupid thought. This must have been part of God’s plan all along.</p>
<p class="basic-paragraph">It was a woman. Thomas didn’t know how he knew, but he was certain it was a woman.</p>
<p class="basic-paragraph">Again, he struggled with himself. Something was askew. The revelation of God’s will, where once it had filled him with excitement, now brought nothing but unease.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// thefollowers_00007.vue?347062cf